import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PaymentModeResponseDto } from '@core/services/apiclient';
import { SalesPaymentModeModel } from '@shared/models/sales-payment-mode.model';
import { Observable } from 'rxjs';

export type PaymentMethodDisplayMode = 'detailed' | 'simple';

@Component({
  selector: 'app-payment-method-section',
  templateUrl: './payment-method-section.component.html',
  styleUrl: './payment-method-section.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentMethodSectionComponent {
  selectionTitle= input.required<string>();
  isEditMode = input<boolean>(false);
  form = input<FormGroup | null>(null);
  paymentModes$ = input<Observable<PaymentModeResponseDto[]> | null>(null);
  totalAmount$ = input<Observable<number> | null>(null);
  cancelPaymentModes = input<SalesPaymentModeModel[]>([]);
  availablePaymentModes = input<PaymentModeResponseDto[]>([]);
  selectedPaymentMode = input<PaymentModeResponseDto | null>(null);
  displayMode = input<PaymentMethodDisplayMode>('simple');
  paymentTypes = input<any[]>([]);

  edit = output<void>();
  paymentModeChange = output<PaymentModeResponseDto | null>();
  amountToReturnChange = output<number>();

  onEdit(): void {
    this.edit.emit();
  }

  onPaymentModeChange(mode: PaymentModeResponseDto | null): void {
    this.paymentModeChange.emit(mode);
  }

  onAmountToReturnChange(amount: number): void {
    this.amountToReturnChange.emit(amount);
  }
}
